import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleFetchCompliance(action) {
  const { filtersString, filters } = action.payload;
  try {
    const response = yield call(API.fetchParameterCompliance, {
      filtersString: filtersString || JSON.stringify(filters || {})
    });
    yield put(actions.fetchComplianceSuccess(response.data));
  } catch (error) {
    yield put(actions.fetchComplianceFailure(error));
  }
}

function* handleFetchFilters(action) {
  try {
    const response = yield call(API.fetchAllTestCategories);
    yield put(actions.fetchFiltersSuccess(response.data));
  } catch (error) {
    yield put(actions.fetchFiltersFailure(error));
  }
}

export function* parameterComplianceSaga() {
  yield takeLatest(actions.fetchCompliance.type, handleFetchCompliance);
  yield takeLatest(actions.fetchFilters.type, handleFetchFilters);
}